module.exports = __webpack_public_path__ + "img/item-11.a4937dc6.png";